module.exports = __webpack_public_path__ + "static/paleosite_morphing4_bw-6fd4378a12747cacb32309c443cdd5e1.png";